export const restaurant = (state) => state.restaurant
export const restaurant_id = (state) => state.restaurant?.id